import React from 'react'

import CommonStyles from '../styles/common.css'

class YbSubLink extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var message = this.props.message;
    var link = this.props.link;
    var to = this.props.to;

    message = message.split(new RegExp(link));
    return (
      <span>{message[0]}<a className={CommonStyles.link} href={to} target="_blank">{link}</a>{message[1]}</span>
    );
  }
};

module.exports = YbSubLink;
